"use strict"
exports.__esModule = true;
exports.OutlinedFolderOpenIconConfig = {
  name: 'OutlinedFolderOpenIcon',
  height: 512,
  width: 576,
  svgPath: 'M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z',
  yOffset: 0,
  xOffset: 0,
};
exports.OutlinedFolderOpenIcon = require('../createIcon').createIcon(exports.OutlinedFolderOpenIconConfig);
exports["default"] = exports.OutlinedFolderOpenIcon;